"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const CollectionMetaItem = (0, react_1.forwardRef)(({ children, className, newTag, tag, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("li", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-collection__meta-item', newTag && 'usa-tag usa-tag--new', tag && 'usa-tag', className), ...props, children: children }));
});
exports.default = CollectionMetaItem;
